export const TOOL_LINKS = [
  { testId: 'navbar-sub-accounts-link', href: '/sub-accounts', label: 'Sub-Accounts', description: 'Isolated margin accounts' },
  { testId: 'navbar-stats-link', href: '/trade', label: 'Stats', description: 'Exchange volume & metrics' },
  { testId: 'navbar-explorer-link', href: '/trade', label: 'Explorer', description: 'Blocks & transactions' },
  { testId: 'navbar-markets-link', href: '/trade', label: 'Markets', description: 'All markets — price, OI, funding' },
  {
    testId: 'navbar-funding-market-risk-parameters-link',
    href: '/funding-market-risk-parameters',
    label: 'Funding & Market Risk',
    description: 'Funding & market risk parameters',
  },
  { testId: 'navbar-quant-link', href: '/trade', label: 'Quant', description: 'Programmatic & algorithmic trading' },
  { testId: 'navbar-calculator-link', type: 'button', label: 'Calculator', description: 'PnL, target & liquidation price' },
  { testId: 'navbar-apikeys-link', href: '/trade', label: 'API Keys', description: 'Create & manage API keys' },
  {
    testId: 'navbar-ethereum-gateway-link',
    href: '/trade',
    label: 'Ethereum Gateway',
    description: 'Bridge between Ethereum & Lighter',
  },
]

export const MORE_LINKS = [
  { testId: 'navbar-testnet-link', href: '/trade', label: 'Testnet', description: 'Switch network' },
  {
    testId: 'navbar-robinhood-link',
    href: '/trade',
    label: 'Robinhood Chain',
    description: 'Trade on Robinhood Chain',
  },
  { testId: 'navbar-competitions-link', href: '/trade', label: 'Competitions', description: 'Trading competitions & rewards' },
  { testId: 'navbar-whitepaper-link', href: '/trade', label: 'Whitepaper', description: 'Read the whitepaper' },
  { testId: 'navbar-changelog-link', href: '/trade', label: 'Changelog', description: 'Latest product updates' },
  {
    testId: 'navbar-announcements-history-link',
    href: '/trade',
    label: 'Announcements',
    description: 'Past announcements',
  },
  { testId: 'navbar-docs-link', href: '/trade', label: 'Docs', description: 'Lighter documentation' },
  {
    testId: 'navbar-support-link',
    href: '/trade',
    label: 'Support & Community',
    description: 'Get support from the team',
  },
]
